import React from "react";
import "./styles.css";
import Footer from "./footer/footer";
import Marketing from "./marketing/marketing";
import LandingPage from "./landingPage/landing";
import Header from "./navbar/navbar";
import Services from "./services/services";
import Testimonial from "./testimonial/testimonial";
import About from "./about/about";
import PortfolioCarousel from "./portfolio/portfolioCarousel";
import Portfolioheadings from "./portfolio/portfolioHeadings";
import { CssBaseline } from "@material-ui/core";

const App = () => {
  return (
    <>
      <CssBaseline />
      <Header />
      <main>
        <LandingPage id={"home"} />
        <About />
        <Services id={"services"} />
        <Portfolioheadings id={"portfolio"} />
      </main>
      <PortfolioCarousel />
      <Marketing id="contactus" />
      <main>
        <Testimonial id="testimonial" />
      </main>
      <Footer id="footer" />
    </>
  );
};

export default App;
